import { render, staticRenderFns } from "./StandardArticle.vue?vue&type=template&id=a214eb6e&"
import script from "./StandardArticle.vue?vue&type=script&lang=js&"
export * from "./StandardArticle.vue?vue&type=script&lang=js&"
import style0 from "./StandardArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports